<template>
	<div>
		<el-divider>{{ model.mid ? '修改' : '添加' }}模型</el-divider>
		<el-form class="text-left" ref="modelForm" :rules="rules" :model="model" style="width: 80%;margin: 0 auto;">
			<el-form-item label="模型名称" :label-width="formLabelWidth" prop="modelname">
				<el-input v-model="model.modelname" autocomplete="off" placeholder="请输入模型名称,长度2-50个字符"></el-input>
			</el-form-item>
			<el-form-item label="每页显示数量" :label-width="formLabelWidth" prop="pagemax">
				<el-input v-model="model.pagemax" autocomplete="off" placeholder="请输入每页显示数量,长度2-50个字符"></el-input>
			</el-form-item>
			<el-form-item label="列表Title标题样式" :label-width="formLabelWidth" prop="listtitlestyle">
				<el-input v-model="model.listtitlestyle" autocomplete="off" placeholder="请输入每页显示数量,长度2-50个字符"></el-input>
				<el-alert title="格式说明：{typename}当前分类名称，{sitename}网站名称" type="info" show-icon></el-alert>
			</el-form-item>
			<el-form-item label="阅读Title标题样式" :label-width="formLabelWidth" prop="readtitlestyle">
				<el-input v-model="model.readtitlestyle" autocomplete="off" placeholder="请输入每页显示数量,长度2-50个字符"></el-input>
				<el-alert title="格式说明：{title}当前内容标题，{typename}当前分类名称，{sitename}网站名称" type="info" show-icon></el-alert>
			</el-form-item>
			<el-form-item label="编号录入方式" :label-width="formLabelWidth">
				<el-radio v-model="model.istsn" :label="1">自动生成编号</el-radio>
				<el-radio v-model="model.istsn" :label="0">关闭编号</el-radio>
			</el-form-item>
			<el-form-item label="编号生成格式" :label-width="formLabelWidth" prop="tsnstyle">
				<el-input v-model="model.tsnstyle" autocomplete="off" placeholder="请输入每页显示数量,长度2-50个字符"></el-input>
				<el-alert title="格式说明：{datetime}：年月日时间，{data}：年月日，{y}：年，{m}：月，{d}：日，{time}：时间，{s}：随机数" type="info" show-icon></el-alert>
			</el-form-item>
			<el-form-item label="单页发布功能" :label-width="formLabelWidth">
				<el-radio v-model="model.isbase" :label="1">开启</el-radio>
				<el-radio v-model="model.isbase" :label="0">关闭</el-radio>
				<el-alert title="选择单页发布功能后，此模型所关联的内容只能发布单页信息，如公司介绍" type="info" show-icon></el-alert>
			</el-form-item>
			<el-form-item label="频道主页模板" :label-width="formLabelWidth" prop="index_templates">
				<el-input v-model="model.index_templates" autocomplete="off" placeholder="请输入每页显示数量,长度2-50个字符">
					<template slot="append">
						<el-button icon="el-icon-document" @click="chooseTemplate('index_templates')">选择模板</el-button>
					</template>
				</el-input>
			</el-form-item>
			<el-form-item label="列表模板" :label-width="formLabelWidth" prop="list_templates">
				<el-input v-model="model.list_templates" autocomplete="off" placeholder="请输入每页显示数量,长度2-50个字符">
					<template slot="append">
						<el-button icon="el-icon-document" @click="chooseTemplate('list_templates')">选择模板</el-button>
					</template>
				</el-input>
			</el-form-item>
			<el-form-item label="阅读模板" :label-width="formLabelWidth" prop="read_templates">
				<el-input v-model="model.read_templates" autocomplete="off" placeholder="请输入每页显示数量,长度2-50个字符">
					<template slot="append">
						<el-button icon="el-icon-document" @click="chooseTemplate('read_templates')">选择模板</el-button>
					</template>
				</el-input>
			</el-form-item>
			<el-form-item label="相册功能" :label-width="formLabelWidth">
				<el-radio v-model="model.isalbum" :label="1">开启</el-radio>
				<el-radio v-model="model.isalbum" :label="0">关闭</el-radio>
				<el-alert title="启用相册后，在内容中可以选择多图功能" type="info" show-icon></el-alert>
			</el-form-item>
			<el-form-item label="附加分类" :label-width="formLabelWidth">
				<el-radio v-model="model.isextid" :label="1">开启</el-radio>
				<el-radio v-model="model.isextid" :label="0">关闭</el-radio>
				<el-alert title="启用附加分类后，在内容中可以选择附加分类功能" type="info" show-icon></el-alert>
			</el-form-item>
			<el-form-item label="品牌专题" :label-width="formLabelWidth">
				<el-radio v-model="model.issid" :label="1">开启</el-radio>
				<el-radio v-model="model.issid" :label="0">关闭</el-radio>
				<el-alert title="启用品牌专题后，在内容中可以选择品牌专题功能" type="info" show-icon></el-alert>
			</el-form-item>
			<el-form-item label="表单功能" :label-width="formLabelWidth">
				<el-radio v-model="model.isfgid" :label="1">开启</el-radio>
				<el-radio v-model="model.isfgid" :label="0">关闭</el-radio>
				<el-alert title="启用表单功能后，在内容中可以选择关联表单功能" type="info" show-icon></el-alert>
			</el-form-item>
			<el-form-item label="内容关联" :label-width="formLabelWidth">
				<el-radio v-model="model.islinkdid" :label="1">开启</el-radio>
				<el-radio v-model="model.islinkdid" :label="0">关闭</el-radio>
				<el-alert title="启用内容关联后，在内容中可以选择内容关联功能" type="info" show-icon></el-alert>
			</el-form-item>
			<!-- <el-form-item label="投票功能" :label-width="formLabelWidth">
				<el-radio v-model="model.isques" :label="1">开启</el-radio>
				<el-radio v-model="model.isques" :label="0">关闭</el-radio>
				<el-alert title="启用投票功能后，可在内容中关联相关投票选项" type="info" show-icon></el-alert>
			</el-form-item>
			<el-form-item label="订单功能" :label-width="formLabelWidth">
				<el-radio v-model="model.isorder" :label="1">开启</el-radio>
				<el-radio v-model="model.isorder" :label="0">关闭</el-radio>
				<el-alert title="启用订单功能后，在内容中可以使用在线订单功能" type="info" show-icon></el-alert>
			</el-form-item>
			<el-form-item label="跟帖留言" :label-width="formLabelWidth">
				<el-radio v-model="model.ismessage" :label="1">开启</el-radio>
				<el-radio v-model="model.ismessage" :label="0">关闭</el-radio>
				<el-alert title="启用跟贴留言后，在内容中可以控制内容跟贴留言功能" type="info" show-icon></el-alert>
			</el-form-item> -->
			<el-form-item label="访问权限设置" :label-width="formLabelWidth">
				<el-radio v-model="model.ispurview" :label="1">开启</el-radio>
				<el-radio v-model="model.ispurview" :label="0">关闭</el-radio>
				<el-alert title="启用访问权限控制后，在内容中可以控制内容访问权限控制功能" type="info" show-icon></el-alert>
			</el-form-item>
		</el-form>
		<div style="margin-bottom: 15px;">
			<el-button type="primary" @click="submitForm('modelForm')">确定保存</el-button>
			<el-button type="default" @click="turnBack()">取消添加</el-button>
		</div>
		<!-- 模板文件选择组件 -->
		<tempfile-list ref="tempfile" @confirm="chooseTempfileConfirm"></tempfile-list>
	</div>
</template>
<script>
import tempfileList from '../../components/tempfilelist/tempfilelist.vue';
export default {
	name: 'addModel',
	components: {
		tempfileList
	},
	data() {
		return {
			model: {
				mid: '',
				modelname: '',
				pagemax: '20',
				listtitlestyle: '{typename}-{sitename}',
				readtitlestyle: '{title}-{typename}-{sitename}',
				istsn: 1,
				tsnstyle: 'SN{datetime}{s}',
				isbase: 0,
				index_templates: '',
				list_templates: '',
				read_templates: '',
				isalbum: 1,
				isextid: 1,
				issid: 1,
				isfgid: 1,
				islinkdid: 1,
				isques: 1,
				isorder: 1,
				ismessage: 1,
				ispurview: 1
			},
			rules: {
				modelname: [{ required: true, message: '请输入模型名称', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
				attrname: [{ required: true, message: '请输入模型代号', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
				inputtype: [{ required: true, message: '请选择模型类型', trigger: 'blur' }]
			},
			formLabelWidth: '130px',
			tempattr:'',//模板字段名
		};
	},
	mounted() {
		let mid = this.$route.query.mid;
		if (mid) {
			this.getModelInfo(mid);
		}
	},
	methods: {
		getModelInfo(mid) {
			this.$axios({
				url: this.HOST + '/admin.document/getModelInfo',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					mid: mid
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.model = res.data.model;
					}
				})
				.catch(err => {});
		},
		submitForm(ruleform){
			this.$refs[ruleform].validate((valid,attr) => {
				if (valid) {
					this.addModel();
				} else {
					console.log('error submit!!',attr);
					return false;
				}
			})
		},
		addModel(){
			this.$axios({
				url: this.HOST + '/admin.document/addModel',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					model: this.model
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						this.$router.go(-1);
					}
				})
				.catch(err => {});
		},
		// 打开模板列表组件
		chooseTemplate(tempattr){
			this.tempattr = tempattr;
			this.$refs.tempfile.show();
		},
		// 选择模板文件
		chooseTempfileConfirm(e){
			this.model[this.tempattr] = e;
		},
	}
};
</script>
<style lang="scss">
.el-button + .el-button-group {
	margin-left: 10px;
	margin-right: 10px;
}
.el-form-item{
	margin-bottom: 20px;
}
.el-alert{
	display: inline;
	.el-alert__content{
		line-height: 20px;
	}
} 
</style>
